import React from "react";
import PropTypes from "prop-types";
import StyledButton from "../StyledButton/StyledButton";
import styled, { withTheme } from "styled-components";

const StyledAccentBtn = styled(StyledButton)`
  color: ${(props) => props?.theme?.white};
  background-color: ${(props) => props?.theme?.yellowGreen};
  border-color: ${(props) => props?.theme?.yellowGreen};
  &:hover {
    color: ${(props) => props?.theme?.theme?.white} !important;
    background-color: ${(props) => props?.theme?.lightGreen} !important;
    border-color: ${(props) => props?.theme?.lightGreen} !important;
  }
  &:focus {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) => props?.theme?.lightGreen};
    border-color: ${(props) => props?.theme?.lightGreen};
    box-shadow: ${(props) => props?.theme?.accentShadow};
  }
  &:disabled,
  &:not(:disabled):not(.disabled):active,
  :not(:disabled):not(.disabled).active,
  .show > .dropdown-toggle {
    color: ${(props) => props?.theme?.white};
    background-color: ${(props) => props?.theme?.pixieGreen};
    border-color: ${(props) => props?.theme?.pixieGreen};
  }
  &:not(:disabled):not(.disabled):active:focus,
  .show > .dropdown-toggle:focus {
    box-shadow: ${(props) => props?.theme?.accentShadow};
  }
`;

const AccentButton = (props) => {
  const { text, size } = props;

  return (
    <StyledAccentBtn {...props} size={size}>
      {text || props.children}
    </StyledAccentBtn>
  );
};

AccentButton.propTypes = {
  size: PropTypes.oneOf(["lg", "", "sm"]),
};

export default withTheme(AccentButton);
